import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/billing/overview",
	lazy(() => import("./AdminBillingPage"))
);
